export default "__VITE_PUBLIC_ASSET__5fdc3890__"